import React, { Component } from 'react';
import DetailsForm from '../molecules/DetailsForm';

class ParticipantDetails extends Component {

  render() {
    return (
      <main>
        <h1>Before we begin</h1>
        <p>Please submit your:</p>
        <DetailsForm/>
      </main>
    )
  }
}

export default ParticipantDetails;
